import { ShieldCheckIcon } from "@heroicons/react/24/outline";
import { cn } from "@/lib/utils";

export const ConfidentialComputeBadge = ({ size = "small" }: { size?: "small" | "medium" }) => {
  return (
    <div
      className={cn(
        "flex w-fit flex-shrink-0 items-center gap-1 rounded-full border border-[#3291FF] bg-[#083D86] font-medium leading-[130%] text-[#D3E5FF]",
        size === "small" ? "px-[6px] py-[2px] text-[10px]" : "px-2 py-[6px] text-[12px]"
      )}
    >
      <ShieldCheckIcon className={cn("h-3 w-3", size === "small" ? "h-3 w-3" : "h-4 w-4")} />{" "}
      Confidential Compute
    </div>
  );
};
